/*
 * types/services/dr2am.tasks.orders.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbOrder} from './PbOrder';
import {ProtobufFieldMask} from './ProtobufFieldMask';

/**
 * The ServiceUpdateOrdersRequest model module.
 * @module model/ServiceUpdateOrdersRequest
 * @version version not set
 */
export class ServiceUpdateOrdersRequest {
  /**
   * Constructs a new <code>ServiceUpdateOrdersRequest</code>.
   * @alias module:model/ServiceUpdateOrdersRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdateOrdersRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdateOrdersRequest} obj Optional instance to populate.
   * @return {module:model/ServiceUpdateOrdersRequest} The populated <code>ServiceUpdateOrdersRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdateOrdersRequest();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('order'))
        obj.order = PbOrder.constructFromObject(data['order']);
      if (data.hasOwnProperty('update_mask'))
        obj.updateMask = ProtobufFieldMask.constructFromObject(data['update_mask']);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
ServiceUpdateOrdersRequest.prototype.id = undefined;

/**
 * @member {module:model/PbOrder} order
 */
ServiceUpdateOrdersRequest.prototype.order = undefined;

/**
 * @member {module:model/ProtobufFieldMask} updateMask
 */
ServiceUpdateOrdersRequest.prototype.updateMask = undefined;


